import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { BiCalendar, BiEdit, BiTrash } from "react-icons/bi";
import { FiFileText } from "react-icons/fi";
import { getNoteByID, deleteNote } from "../../services/api/NoteApi";
import DeleteConfirmationModal from "../../components/DeleteConfirmationModal/DeleteConfirmationModal";
import "./ViewNote.scss";
import { useLoading } from "../../context/LoadingContext";
import { truncatePartyNames,formatText } from "../../components/TruncateParties";

const ViewNote = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const { parties } = location.state || {};
  const [note, setNote] = useState(null);
  const [error, setError] = useState(null);
  const { showLoading, hideLoading } = useLoading();
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  useEffect(() => {
    const fetchNote = async () => {
      try {
        showLoading("Loading note details...");
        const response = await getNoteByID(id);
        setNote(response.data);
      } catch (err) {
        console.error(err);
        setError("Failed to fetch note details.");
      } finally {
        hideLoading();
      }
    };

    if (id) {
      fetchNote();
    }
  }, [id]);

  // START: Add handler functions
  const handleEdit = () => {
  navigate(`/home/notes/edit-note/${id}`, {
    state: { noteData: note }
  });
};

  const handleDelete = () => {
    setShowDeleteModal(true);
  };

  const confirmDelete = async () => {
    try {
      await deleteNote(id);
      navigate("/home/notes");
    } catch (err) {
      console.error("Error deleting note:", err);
    }
    setShowDeleteModal(false);
  };

  const cancelDelete = () => {
    setShowDeleteModal(false);
  };
  // END: Add handler functions

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "2-digit",
    });
  };

  if (error) {
    return <div className="error-message">{error}</div>;
  }

  if (!note) {
    return null; // Loading is handled globally
  }

  return (
    <div className="note-detail-container">
      <div className="note-card">
        <div className="note-header">
          <div className="note-header-data">
            <div className="avatar">{note.title?.charAt(0)}</div>
            <div className="note-title">
              <h2>{formatText(note.title)}</h2>
              {note.courtRef && (
                <span className="note-tag" onClick={(e) => { e.stopPropagation(); navigate(`/home/cases/casedetails/${note.courtRef}`); }}>
                  {note.courtRef} - ({truncatePartyNames(parties)})
                </span>
              )}
            </div>
          </div>
          <div className="client-actions">
            <button className="btn-update" onClick={handleEdit}>
              <BiEdit /> Update
            </button>
            <button className="btn-delete" onClick={handleDelete}>
              <BiTrash /> Delete
            </button>
          </div>
        </div>

        <div className="note-details-grid">
          <div className="detail-item">
            <BiCalendar className="icon" />
            <div>
              <label>Created</label>
              <p>{formatDate(note.createdAt)}</p>
            </div>
          </div>

          <div className="detail-item">
            <BiCalendar className="icon" />
            <div>
              <label>Last Updated</label>
              <p>{formatDate(note.updatedAt)}</p>
            </div>
          </div>

          {/* <div className="detail-item">
            <BiHash className="icon" />
            <div>
              <label>Note ID</label>
              <p>{note._id}</p>
            </div>
          </div> */}
        </div>

        <div className="detail-item any-desc">
          <FiFileText className="icon" />
          <div>
            <label>Content</label>
            {note.content ? (
              <div dangerouslySetInnerHTML={{ __html: note.content }} />
            ) : (
              <p>No description provided</p>
            )}
          </div>
        </div>
      </div>

      <DeleteConfirmationModal
        isOpen={showDeleteModal}
        onClose={cancelDelete}
        onConfirm={confirmDelete}
        itemType={`note "${note?.title}"`}
        onCancel={cancelDelete}
      />
    </div>
  );
};

export default ViewNote;